import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useForm } from "react-hook-form";
import Paper from "@mui/material/Paper";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import "../components/Table/Table.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import { allChecklist, getAllQuestions, submitQuestion } from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination, Tooltip, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddIcon from "@mui/icons-material/Add";

const AllQuestions = ({ role, userData }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [questionType, setQuestionType] = useState("");
  const [questionContent, setQuestionContent] = useState("");
  const [option, setOption] = useState([]);
  const [optionContent, setOptionContent] = useState("");
  const [addQuestion, setAddQuestion] = useState(false);
  const [qIndex, setQindex] = useState(0);
  const [oIndex, setOindex] = useState(0);
  const [question, setQuestion] = useState([]);
  const [subInput, setSubInput] = useState(0);
  const [back, setBack] = useState(false);

  let typeObj = {
    input: 0,
    image: 1,
    radio: 2,
  };

  let custom_inputObj = {
    "N/A": 0,
    "alpha-numeric": 1,
    numeric: 2,
    alphabets: 3,
  };

  useEffect(() => {
    setIsLoading(true);
    getAllQuestions(id)
      .then((res) => {
        if (res.status === "success") {
          setFilteredData(res.data.Result);
        } else {
          toast.error("Failed to fetch questions");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error("Something went wrong");
        setIsLoading(false);
      });
  }, [id, back]);

  const handleChangeInput = (e) => {
    console.log(e.target.value);
    setQuestionType(e.target.value);
  };

  const handleAddOption = (qindex) => {
    setQindex((val) => val + 1);
    setAddQuestion(true);
  };

  const handleOnBack = (e) => {
    setAddQuestion((val) => !val);
    // window.location.reload();
    setBack((val) => !val);
  };

  const handleClickToAdd = () => {
    // let obj = {
    //   checkList_id: id,
    //   qIndex: qIndex,
    //   questionType: questionType,
    //   questionContent: questionContent,
    //   option: option,
    // };
    // console.log(obj);
    // setQuestion((arr) => [...arr, obj]);
    // setAddQuestion(false);
    // setQuestionType("");
    // setOption([]);
    setIsLoading(true);

    const postData = {
      checklist_id: id,
      question: questionContent,
      type: typeObj[questionType],
      custom_input: subInput,
      custom_input_type: 1,
      custom_question: 1,
      options: option,
    };

    submitQuestion(postData)
      .then((res) => {
        if (res.status === "success") {
          toast.success("Question Added Successfully");
        } else {
          toast.error("Failed to fetch questions");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error("Something went wrong");
        setIsLoading(false);
      });

    setQuestionType("");
    setSubInput(0);
    setQuestionContent("");
    setOption([]);
    setOindex(0);
  };

  const handleChangeOption = (e) => {
    setOptionContent(e.target.value);
  };

  const handleChangeQuestion = (e) => {
    setQuestionContent(e.target.value);
  };

  const handleAddOptionClick = (oIndex) => {
    setOindex((val) => val + 1);
    setOption((val) => [...val, optionContent]);
    setOptionContent("");
  };

  const handlesubInputChange = (e) => {
    // switch (e.target.value) {
    //   case 'alpha-numeric':
    //     setSubInput(1);
    //     break;
    //   case 'numeric':
    //     setSubInput(2);
    //     break;
    //   case 'alphabets':
    //     setSubInput(3);
    //     break;
    //   default:
    //     setSubInput(0);
    // }

    setSubInput(
      custom_inputObj[
        Object.keys(custom_inputObj).filter((val) => val === e.target.value)[0]
      ]
    );
  };

  // const handleOnSubmit = () => {
  //   setIsLoading(true);

  //   const postData = {
  //     checklist_id: id,
  //     question: questionContent,
  //     type: question.length!=0?question[0].questionType:[],
  //     options: question.length!=0?question[0].option:[],
  //   };

  //   submitQuestion(postData)
  //     .then((res) => {
  //       if (res.status === "success") {
  //         toast.success("Question Added Successfully");
  //       } else {
  //         toast.error("Failed to fetch questions");
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       toast.error("Something went wrong");
  //       setIsLoading(false);
  //     });
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleDelete = (index) => {
    const updatedDatas = option.filter((val,idx)=>val!=option[index])
    setOption(updatedDatas);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-4 bg-white">
        {/* <div className="construction"></div> */}
      </div>
      <div className="px-0 px-md-3">
        <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Questions")}</h5>
          <div style={{ display: role == 7 ? "none" : "block" }}>
            {!addQuestion && (
              <button
                className="btn btn-primary btn-sm me-2"
                onClick={() => navigate(-1)}
              >
                <ArrowBackIosIcon />
                {t("Go Back")}
              </button>
            )}
            {addQuestion && (
              <button
                className="btn btn-primary btn-sm me-2"
                onClick={handleOnBack}
              >
                <ArrowBackIosIcon />
                {t("Go Back")}
              </button>
            )}
            {!addQuestion && (
              <button
                onClick={() => handleAddOption(qIndex)}
                className="btn btn-primary btn-sm"
              >
                <AddIcon />
                {t("Add New")}
              </button>
            )}
          </div>
        </div>
        {addQuestion && (
          <div>
            <div className="col-md-12" style={{ display: "flex" }}>
              <div className="col-md-5 me-5">
                <label className="form-label">
                  {t("Select Question Type")}
                  <span className="text-danger"> *</span>
                </label>
                <select
                  name="answer"
                  className="common-input form-select"
                  onChange={handleChangeInput}
                  value={questionType}
                  required
                >
                  <option value="">{t("Select Question type")}</option>
                  <option value="input">{t("Input field")}</option>
                  <option value="image">{t("Image")}</option>
                  <option value="radio">{t("Radio")}</option>
                </select>
              </div>
              {questionType === "input" && (
                <div className="col-md-5">
                  <label className="form-label">
                    {t("Select Answer Format")}
                    <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="answer"
                    className="common-input form-select"
                    onChange={handlesubInputChange}
                    required
                  >
                    <option value="">{t("Select Answer Format")}</option>
                    <option value="alpha-numeric">
                      {t("Alpha-Numeric Text")}
                    </option>
                    <option value="numeric">{t("Numeric only")}</option>
                    <option value="alphabets">{t("Alphabets only")}</option>
                  </select>
                </div>
              )}
            </div>
            <div className="col-md-12 mt-3">
              <label className="form-label">
                {t("Question")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="textarea"
                name="question"
                placeholder="Enter Your Question..."
                className="form-control"
                value={questionContent}
                onChange={handleChangeQuestion}
                required
              />
            </div>
            {questionType === "radio" && (
              <div>
                <div>
                  <div className="col-md-12 mt-3">
                    <label className="form-label">
                      {t("Add Most suited option ")}{" "}
                      {<span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="textarea"
                      name="option"
                      placeholder="Enter Option..."
                      value={optionContent}
                      className="form-control"
                      onChange={handleChangeOption}
                      required
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => handleAddOptionClick(oIndex)}
                    style={{ margin: "10px" }}
                  >
                    {t("Add Option")}
                  </button>
                  {option.length !== 0 && (
                    <table className="table table-bordered mt-3">
                      <thead>
                        <tr>
                          <th>{t("Sl No.")}</th>
                          <th>{t("Option Content")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {option.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{val}</td>
                            <td style={{ width: "10%" }}>
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleDelete(index)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            )}
            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleClickToAdd()}
              style={{ margin: "10px" }}
            >
              {t("Add Question")}
            </button>
          </div>
        )}
        {question.length !== 0 && (
          <div>
            <table className="table table-bordered mt-3">
              <thead>
                <tr>
                  <th>{t("Sl No")}</th>
                  <th>{t("Question Type")}</th>
                  <th>{t("Question Content")}</th>
                </tr>
              </thead>
              <tbody>
                {question.map((val, index) => (
                  <tr key={index}>
                    <td>{val.qIndex}</td>
                    <td>{val.questionType}</td>
                    <td>{val.questionContent}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* <button
              type="button"
              className="btn btn-success"
              onClick={() => handleOnSubmit()}
              style={{ margin: "10px" }}
            >
              {t("Submit")}
            </button> */}
          </div>
        )}
        {!addQuestion && (
          <div className="Table mb-6">
            <TableContainer
              component={Paper}
              style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
              className="my-4"
            >
              <Table sx={{ minWidth: 800 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: "4rem" }}>Sr. No.</TableCell>
                    <TableCell style={{ width: "20rem" }} align="center">
                      Question
                    </TableCell>
                    <TableCell align="center">Total Option</TableCell>
                    <TableCell align="center">Type</TableCell>
                    <TableCell align="center">Custom Input</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                {!isLoading && filteredData && filteredData.length > 0 && (
                  <TableBody style={{ color: "white" }}>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {index + 1}
                          </TableCell>
                          <TableCell align="center">{row.question}</TableCell>
                          <TableCell align="center">
                            {row.total_options}
                          </TableCell>
                          <TableCell align="center">
                            {Object.keys(typeObj)
                              .filter((val) => typeObj[val] === row.type)[0]
                              .split("")
                              .map((val, index) =>
                                index === 0 ? `${val.toUpperCase()}` : `${val}`
                              )
                              .join("")}
                          </TableCell>
                          <TableCell align="center">
                            {Object.keys(custom_inputObj)
                              .filter(
                                (val) =>
                                  custom_inputObj[val] === row.custom_input
                              )[0]
                              .split("")
                              .map((val, index) =>
                                index === 0 ? `${val.toUpperCase()}` : `${val}`
                              )
                              .join("")}
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title="Edit Question">
                              <IconButton>
                                <BorderColorOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                )}
                {!isLoading && (!filteredData || filteredData.length === 0) && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={7}>
                        <h4>
                          <i>No data available</i>
                        </h4>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default AllQuestions;
